import React, { useEffect } from 'react';
import { useInViewport } from 'ahooks';
import { useRef } from 'react';

interface IProps {
    // id: string;
    onlyFirst?: boolean;
    /** 默认仅首次出现触发 */
    onDisplay: (show: boolean) => void;
    children: React.ReactNode;
    [key: string]: any;
}
export const ObserverIntersectionView = (props: IProps) => {
    const { onDisplay, onlyFirst = true, children, ...otherProps } = props;
    const ref = useRef<HTMLDivElement | null>(null);
    const [inViewport] = useInViewport(ref);

    const isFirst = useRef(false);
    useEffect(() => {
        if (inViewport) {
            if (!isFirst.current && onlyFirst) {
                onDisplay(true);
                isFirst.current = true;
            } else {
                onDisplay(true);
            }
        }
    }, [onlyFirst, inViewport, onDisplay]);

    return (
        <div ref={ref} {...otherProps}>
            {children}
        </div>
    );
};
